<script lang="ts">
	import { setContext } from 'svelte';
	export let hash: symbol | null = null;

	setContext('stepHash', hash);
</script>

<slot />
